export default __webpack_public_path__ + "static/media/Inter-Black.54c4088f.ttf";